export const getLayerPresets = function (layer_type: string,
                                         fatigue_cracking: {low: string, medium: string, high:string},
                                         transverse_cracking: {low: string, medium: string, high:string}) {
  const layerTypes = [
    'Asphalt - Open Graded',
    'Asphalt - Dense Graded',
    'Cement treated base',
    'Bituminous treated base',
    'Asphalt stabilized base',
    'Aggregate Base'
  ];

  const layerMatch = layerTypes.includes(layer_type);
  if (!layerMatch){
    console.log("Layer type " + layer_type + " not found.");
    return 'Invalid layer type'
  }

  if (layer_type === 'Asphalt - Open Graded' || layer_type === 'Asphalt - Dense Graded') {
    return getAsphaltPresets(fatigue_cracking, transverse_cracking);
  } else if (layer_type === 'Cement treated base' || layer_type === 'Bituminous treated base' || layer_type === 'Asphalt stabilized base') {
    return getStabilizedPresets(fatigue_cracking, transverse_cracking);
  } else {
    return getSubgradePresets(fatigue_cracking, transverse_cracking);
  }
};

export const getAsphaltPresets = function (fatigue_cracking: {low: string, medium: string, high:string},
                                           transverse_cracking: {low: string, medium: string, high:string}) {
  if (!fatigue_cracking
    || !transverse_cracking
    || fatigue_cracking.low === undefined
    || fatigue_cracking.medium === undefined
    || fatigue_cracking.high === undefined
    || transverse_cracking.low === undefined
    || transverse_cracking.medium === undefined
    || transverse_cracking.high === undefined
  ) {
    return "0.35 to 0.40";
  }
  if (fatigue_cracking.high === ">10" || transverse_cracking.high === ">10") {
    return "0.08 to 0.15";
  }
  if (fatigue_cracking.medium === ">10" || transverse_cracking.medium === ">10" || fatigue_cracking.high === "<10") {
    return "0.14 to 0.20";
  }
  if (fatigue_cracking.low === ">10" || fatigue_cracking.medium === "<10" || transverse_cracking.medium === "5-10" || transverse_cracking.high === "5-10") {
    return "0.20 to 0.30";
  }
  if (fatigue_cracking.low === "<10" || transverse_cracking.medium === "<5" || transverse_cracking.high === "<5") {
    return "0.25 to 0.35";
  }
  return "0.35 to 0.40";
};

export const getStabilizedPresets = function (fatigue_cracking: {low: string, medium: string, high:string},
                                              transverse_cracking: {low: string, medium: string, high:string}) {
  if (!fatigue_cracking
    || !transverse_cracking
    || fatigue_cracking.low === undefined
    || fatigue_cracking.medium === undefined
    || fatigue_cracking.high === undefined
    || transverse_cracking.low === undefined
    || transverse_cracking.medium === undefined
    || transverse_cracking.high === undefined
  ) {
    return "0.20 to 0.35";
  }
  if (fatigue_cracking.high === ">10" || transverse_cracking.high === ">10") {
    return "0.08 to 0.15";
  }
  if (fatigue_cracking.medium === ">10" || transverse_cracking.medium === ">10" || fatigue_cracking.high === "<10") {
    return "0.10 to 0.20";
  }
  if (fatigue_cracking.low === ">10" || fatigue_cracking.medium === "<10" || transverse_cracking.medium === "5-10" || transverse_cracking.high === "5-10") {
    return "0.15 to 0.20";
  }
  if (fatigue_cracking.low === "<10" || transverse_cracking.medium === "<5" || transverse_cracking.high === "<5") {
    return "0.15 to 0.25";
  }
  return "0.20 to 0.35";
};

export const getSubgradePresets = function (fatigue_cracking: {low: string, medium: string, high:string},
                                            transverse_cracking: {low: string, medium: string, high:string}) {
  if (!fatigue_cracking
    || !transverse_cracking
    || fatigue_cracking.low === undefined
    || fatigue_cracking.medium === undefined
    || fatigue_cracking.high === undefined
    || transverse_cracking.low === undefined
    || transverse_cracking.medium === undefined
    || transverse_cracking.high === undefined
  ) {
    return "0.1 to 0.14";
  }
  if (fatigue_cracking.low != "0"
    || fatigue_cracking.medium != "0"
    || fatigue_cracking.high != "0"
    || transverse_cracking.low != "0"
    || transverse_cracking.medium != "0"
    || transverse_cracking.high != "0") {
    return "0.00 to 0.1";
  }
  return "0.1 to 0.14";
};
